/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Mode_3_DescInputs */

const en_mk_loop_mode_3_desc = /** @type {(inputs: Mk_Loop_Mode_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every task waits for your approval. For auth, payments and anything touching customer data.`)
};

const id_mk_loop_mode_3_desc = /** @type {(inputs: Mk_Loop_Mode_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap task menunggu persetujuanmu. Untuk auth, pembayaran, dan kode yang menyentuh data pelanggan.`)
};

/**
* | output |
* | --- |
* | "Every task waits for your approval. For auth, payments and anything touching customer data." |
*
* @param {Mk_Loop_Mode_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_mode_3_desc = /** @type {((inputs?: Mk_Loop_Mode_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Mode_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_mode_3_desc(inputs)
	return en_mk_loop_mode_3_desc(inputs)
});